import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import WriteJsonArrayForm from '../forms/write-json-array-form';
import { jsonArrayWriteValidationSchema } from '../schema/json.js';

export default function WriteJsonArrayNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Write JSON Array Node Details',
        altText: 'Write JSON Array Node',
        defaultLabel: 'Write JSON Array Node',
      }}
    >
      <CommonNode
        FormComponent={WriteJsonArrayForm}
        schemaResolver={jsonArrayWriteValidationSchema}
      />
    </NodeProvider>
  );
}
